// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Booking_modal__img__9tMfW {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.Booking_main_nav__CTZ50 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 1rem;
  background-color: var(--color-dark-2);
  box-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);
  color: var(--color-white);
}
.Booking_main_nav__CTZ50 > :not(:last-child) {
  margin-right: 6rem;
}
.Booking_main_nav_group__BLS0n {
  position: relative;
}
.Booking_main_nav_more__s2lXR {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-dark-2);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Booking_main_nav_more__s2lXR > :not(last-child) {
  margin-bottom: 1rem;
}
.Booking_main_nav_item__tjCac {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Booking_main_nav_item__tjCac:hover, .Booking_main_nav_item__tjCac:focus, .Booking_main_nav_item__tjCac:focus-visible, .Booking_main_nav_item__tjCac:focus-within {
  font-weight: 700;
  color: var(--color-white);
  border-bottom: solid 2px var(--color-white);
}
.Booking_main_nav_item_active__R1fH0 {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary-3);
  border-bottom: solid 2px var(--color-primary-3);
}
.Booking_main_nav_item_active__R1fH0:hover, .Booking_main_nav_item_active__R1fH0:focus, .Booking_main_nav_item_active__R1fH0:focus-visible, .Booking_main_nav_item_active__R1fH0:focus-within {
  font-weight: 700;
  color: var(--color-primary-3);
  border-bottom: solid 2px var(--color-primary-3);
}
.Booking_main__content__Lh-p8 {
  margin-top: 5rem;
}
.Booking_main__metrics__fA6Ez {
  padding: 3.5rem 2rem;
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Booking_main__metrics__fA6Ez {
    grid-template-columns: repeat(2, 50%);
  }
}
.Booking_main__metrics_active__Qq8Ho {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Booking_main__metrics_suspended__14Tfb {
  background-color: var(--color-yellow);
}
.Booking_main__metrics_terminated__qZQIJ {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Booking_main__center__WYGOZ {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Booking_createLinks__6vnEq {
  display: flex;
  justify-content: center;
}
.Booking_createLinks_1__ZT6T4 {
  background-color: var(--color-white);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 60%;
}
@media only screen and (max-width: 50em) {
  .Booking_createLinks_1__ZT6T4 {
    width: 100%;
  }
}
.Booking_createLinks_2__TAbfz {
  background-color: var(--color-dark-2);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Booking_createLinks_2__TAbfz img {
  width: 7rem;
}
.Booking_createLinks_mini__-3kA1 {
  background-color: var(--color-white);
  padding: 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.Booking_beside__79HL- {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .Booking_beside__79HL- {
    grid-template-columns: 100%;
  }
}

.Booking_status__pending__i2Z8v {
  color: var(--color-yellow-3);
}
.Booking_status__paid__0ZtvH {
  color: var(--color-green);
}
.Booking_status__failed__vyreD {
  color: var(--color-error);
}

.Booking_active__SnV7N {
  font-weight: 700;
  color: var(--color-green);
}

.Booking_deactivated__I7l\\+2 {
  font-weight: 700;
  color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Booking/Booking.module.scss"],"names":[],"mappings":"AAGC;EACC,cAAA;EACA,mBAAA;AAFF;;AAOC;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EAEA,qCAAA;EACA,gDAAA;EACA,yBAAA;AALF;AASE;EACC,kBAAA;AAPH;AAUE;EACC,kBAAA;AARH;AAWE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AATH;AAWG;EACC,mBAAA;AATJ;AAaE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAXH;AAiBG;EAIC,gBAAA;EACA,yBAAA;EACA,2CAAA;AAlBJ;AAqBG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,6BAAA;EACA,+CAAA;AAnBJ;AAyBI;EAIC,gBAAA;EACA,6BAAA;EACA,+CAAA;AA1BL;AAkCC;EACC,gBAAA;AAhCF;AAmCC;EAEC,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AAjCF;AAmCE;EATD;IAUE,qCAAA;EAhCD;AACF;AAkCE;EACC,oCAAA;EACA,yBAAA;AAhCH;AAmCE;EACC,qCAAA;AAjCH;AAoCE;EACC,oCAAA;EACA,yBAAA;AAlCH;AAsCC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AApCF;;AAwCA;EACC,aAAA;EACA,uBAAA;AArCD;AAuCC;EACC,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EAEA,UAAA;AAtCF;AAwCE;EARD;IASE,WAAA;EArCD;AACF;AAwCC;EACC,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAtCF;AAwCE;EACC,WAAA;AAtCH;AA0CC;EACC,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,WAAA;AAxCF;;AA4CA;EACC,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AAzCD;AA2CC;EAND;IAOE,2BAAA;EAxCA;AACF;;AA+CC;EACC,4BAAA;AA5CF;AA+CC;EACC,yBAAA;AA7CF;AAgDC;EACC,yBAAA;AA9CF;;AAkDA;EACC,gBAAA;EACA,yBAAA;AA/CD;;AAkDA;EACC,gBAAA;EACA,yBAAA;AA/CD","sourcesContent":["@import '../variables/breakpoints';\n\n.modal {\n\t&__img {\n\t\theight: 7.5rem;\n\t\tmargin-bottom: 3rem;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 1rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-dark-2);\n\t\tbox-shadow: 1px 5px 10px -5px rgba(0,0,0,0.3);\n\t\tcolor: var(--color-white);\n\t\t// border-bottom: solid 1px var(--color-dark);\n\t\t// border-radius: 1rem 1rem 0 0;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 6rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-dark-2);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t&> :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tborder-bottom: solid 2px var(--color-white);\n\t\t\t}\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary-3);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary-3);\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \twidth: 47%;\n\t\t\t\t// }\n\n\t\t\t\t&:hover,\n\t\t\t\t&:focus,\n\t\t\t\t&:focus-visible,\n\t\t\t\t&:focus-within {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tcolor: var(--color-primary-3);\n\t\t\t\t\tborder-bottom: solid 2px var(--color-primary-3);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\n\t}\n\n\t&__content{\n\t\tmargin-top: 5rem;\n\t}\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 50%);\n\t\t}\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_suspended {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\n\t\t&_terminated {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n\n\t&__center {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n}\n\n.createLinks {\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t&_1 {\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n\t\twidth: 60%;\n\t\t\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&_2 {\n\t\tbackground-color: var(--color-dark-2);\n\t\tpadding: 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\timg {\n\t\t\twidth: 7rem;\n\t\t}\n\t}\n\n\t&_mini {\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 2rem;\n\t\tmargin: 1rem 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\twidth: 100%;\n\t}\n}\n\n.beside {\n\tdisplay: grid;\n\tgap: 2rem;\n\tgrid-template-columns: repeat(2, 1fr);\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n\n\n\n.status {\n\t&__pending {\n\t\tcolor: var(--color-yellow-3);\n\t}\n\n\t&__paid {\n\t\tcolor: var(--color-green);\n\t}\n\n\t&__failed {\n\t\tcolor: var(--color-error);\n\t}\n}\n\n.active {\n\tfont-weight: 700;\n\tcolor: var(--color-green);\n}\n\n.deactivated {\n\tfont-weight: 700;\n\tcolor: var(--color-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `Booking_modal__img__9tMfW`,
	"main_nav": `Booking_main_nav__CTZ50`,
	"main_nav_group": `Booking_main_nav_group__BLS0n`,
	"main_nav_more": `Booking_main_nav_more__s2lXR`,
	"main_nav_item": `Booking_main_nav_item__tjCac`,
	"main_nav_item_active": `Booking_main_nav_item_active__R1fH0`,
	"main__content": `Booking_main__content__Lh-p8`,
	"main__metrics": `Booking_main__metrics__fA6Ez`,
	"main__metrics_active": `Booking_main__metrics_active__Qq8Ho`,
	"main__metrics_suspended": `Booking_main__metrics_suspended__14Tfb`,
	"main__metrics_terminated": `Booking_main__metrics_terminated__qZQIJ`,
	"main__center": `Booking_main__center__WYGOZ`,
	"createLinks": `Booking_createLinks__6vnEq`,
	"createLinks_1": `Booking_createLinks_1__ZT6T4`,
	"createLinks_2": `Booking_createLinks_2__TAbfz`,
	"createLinks_mini": `Booking_createLinks_mini__-3kA1`,
	"beside": `Booking_beside__79HL-`,
	"status__pending": `Booking_status__pending__i2Z8v`,
	"status__paid": `Booking_status__paid__0ZtvH`,
	"status__failed": `Booking_status__failed__vyreD`,
	"active": `Booking_active__SnV7N`,
	"deactivated": `Booking_deactivated__I7l+2`
};
export default ___CSS_LOADER_EXPORT___;
